import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../../App";
import { action, API, controller } from "../../../../../api/api";
import { Dialog } from "../../../../../layout";
import AddEditTag from "../../../Tag/AddEditTag";
import { MultiSelect } from "../../../../../controls";

const InputTags = ({ values, setValues, handleInpChg, size = "small" }) => {
  const { authUser } = useContext(AppContext);
  const [tags, setTags] = useState([]);

  const [showTagForm, setShowTagForm] = useState(false);
  const [newAddingValue, setNewAddingValue] = useState("");

  // Get Brand
  useEffect(() => {
    if (authUser.id) {
      // Get Tags
      API(controller.Tag + action.GetAllByOrg).get((res) => {
        res.status === 200 &&
          setTags([...res.result.map((j) => ({ ...j, label: j.name }))]);
      });
    }
    return () => {};
  }, [authUser]);

  const handleAddNewTag = (val) => {
    setNewAddingValue(val);
    setShowTagForm(!showTagForm);
  };
  const handleNewTag = (tag) => {
    if (tag) {
      setTags((x) => [{ ...tag, id: tag.id, label: tag.name }, ...x]);
      setValues((x) => ({
        ...x,
        prodTags: [...x.prodTags, tag.id],
      }));
      setNewAddingValue("");
    }
  };

  return (
    <>
      <MultiSelect
        label="Tags"
        name="prodTags"
        fullWidth
        value={values.prodTags}
        onChange={handleInpChg}
        options={tags}
        enableAddBtn={true}
        handleAdd={handleAddNewTag}
        size={size}
      />

      {/* Add new tag */}
      {showTagForm && (
        <Dialog show={showTagForm} onClose={false} maxWidth="xs">
          <AddEditTag
            {...{
              setShowForm: setShowTagForm,
              openFromOtherSide: true,
              tagName: newAddingValue,
              handleResult: handleNewTag,
            }}
          />
        </Dialog>
      )}
    </>
  );
};

export default InputTags;
